import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

// Translation resources
const resources = {
  en: {
    translation: {
      "welcome": "Welcome to our application",
      "home": "Home",
      "about": "About",
      "contact": "Contact"
    }
  },
  es: {
    translation: {
      "welcome": "Bienvenido a nuestra aplicación",
      "home": "Inicio",
      "about": "Acerca de",
      "contact": "Contacto"
    }
  },
  fr: {
    translation: {
      "welcome": "Bienvenue dans notre application",
      "home": "Accueil",
      "about": "À propos",
      "contact": "Contact"
    }
  }
};

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: "en",
    fallbackLng: "en",
    interpolation: {
      escapeValue: false
    }
  });

export default i18n;